import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {AuthenticateService} from './authenticate.service';

import {environment} from '../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/operator/map';
import 'rxjs/operator/catch';
import 'rxjs/add/observable/throw';

@Injectable()
export class ImageService {

    constructor(private router: Router,
                private http: HttpClient,
                private authenticationService: AuthenticateService) { }
    private headers =  new HttpHeaders({ 'Authorization': 'Bearer ' + this.authenticationService.token});

    addStaffImage(formData, id) {
        return this.http
            .post(environment.apiBaseUrl + 'staff-image/' + id, formData, { headers: this.headers})
            .map((response: Response) => {
                return  response;
            });
    }
    addAutomatImage(formData, id) {
        return this.http
            .post(environment.apiBaseUrl + 'automat-image/' + id, formData, { headers: this.headers})
            .map((response: Response) => {
                return  response;
            });
    }

    addUserImage(formData, id) {
        return this.http
            .post(environment.apiBaseUrl + 'profile-image/' + id, formData, { headers: this.headers})
            .map((response: Response) => {
                return  response;
            });
    }

    productImageUpload(formData, id) {
        return this.http.post(environment.apiBaseUrl + 'product-image/' + id, formData, {headers: this.headers})
            .map((response: Response) => {
                return response;
            })
            // ...errors if any
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    automatModelImageUpload(formData, id) {
        return this.http.post(environment.apiBaseUrl + 'automat-model-image/' + id, formData, {headers: this.headers})
            .map((response: Response) => {
                return response;
            })
            // ...errors if any
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }


    addFirmImage(formData, id): Observable<any> {
        return this.http
            .post(environment.apiBaseUrl + 'firm-image/' + id, formData).pipe(
            );
    }

}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/services/image.service.ts